<template>
  <div id="sdCardStatus" >
    <el-dialog
      title="SD卡状态"
      width="60rem"
      top="2rem"
      :append-to-body="true"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div>
        <el-table ref="channelListTable" :data="sdCardStatusList" style="width: 100%"
                  header-row-class-name="table-header">
          <el-table-column prop="id" label="编号" min-width="80">
          </el-table-column>
          <el-table-column prop="hddName" label="名称" min-width="180">
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="80">
            <template v-slot:default="scope">
              <span v-show="scope.row.status === 'ok'">正常</span>
              <span v-show="scope.row.status === 'formatting'">格式化</span>
              <span v-show="scope.row.status === 'unformatted'">未格式化</span>
              <span v-show="scope.row.status === 'idle'">空闲</span>
              <span v-show="scope.row.status === 'error'">错误</span>
            </template>
          </el-table-column>
          <el-table-column label="格式化进度" min-width="80">
            <template v-slot:default="scope">
              <span v-if="scope.row.formatProgress">{{ scope.row.formatProgress }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="存储容量" min-width="80">
            <template v-slot:default="scope">
              <span >{{ scope.row.capacity }}MB</span>
            </template>
          </el-table-column>
          <el-table-column label="剩余存储容量" min-width="80">
            <template v-slot:default="scope">
              <span >{{ scope.row.freeSpace }}MB</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-button size="medium" type="text" @click="formatSDCard(scope.row)">格式化
              </el-button>
              <el-button size="medium" type="text" @click="sdCardStatus()">刷新</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "sdCardStatus",
  components: {},
  created() {},
  data() {
    return {
      showDialog: false,
      sdCardStatusList: []
    };
  },
  methods: {
    openDialog: function (deviceId, channelId, callback) {
      this.deviceId = deviceId;
      this.channelId = channelId;
      this.showDialog = true;
      this.submitCallback = callback;
      this.sdCardStatus()
    },
    sdCardStatus: function () {
      this.$axios({
        method: 'get',
        url: '/api/device/query/sd-status',
        params: {
          deviceId: this.deviceId,
          channelId: this.channelId,
        }
      }).then( (res)=> {
        this.sdCardStatusList = res.data.data
        console.log(this.sdCardStatusList)
        console.log(res)
      }).catch((error)=> {

      });
    },
    formatSDCard: function (itemData) {
      this.$confirm('确认格式化？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'get',
          url: '/api/device/control/format-sd-card',
          params: {
            deviceId: this.deviceId,
            channelId: this.channelId,
            id: itemData.id,
          }
        }).then( (res)=> {

        }).catch((error)=> {

        });
      }).catch(() => {
      });
    },
    close: function () {
      this.showDialog = false;
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/dialog/sdCardStatus.vue